(function () {
	const initProductAccordion = () => {
		$('.accordion-toggle').click(function() {
			if (!$(this).hasClass('active')) {
				$(this).addClass('active');
				$(this).siblings('.accordion-description').eq($(this).index()).stop().slideDown(300);
			} else {
				$(this).removeClass('active');
				$(this).siblings('.accordion-description').stop().slideUp(300);
			}
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
